export default __webpack_public_path__ + "static/media/src_repairapp_m_1.7801335f.jpg";